import _extends from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className"];
var __jsx = React.createElement;
import React from "react";
import MUIModal from "@mui/material/Modal";
export var ELSModal = function ELSModal(_ref) {
  var className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(MUIModal, _extends({
    className: "es-modal ".concat(className || "")
  }, props, {
    modifiers: [{
      name: "offset",
      options: {
        offset: function offset(_ref2) {
          var placement = _ref2.placement,
            popper = _ref2.popper;
          if (placement === "bottom-end") return [-popper.width, 10];
          if (placement === "bottom-start") return [0, 10];
          return [0, 10];
        }
      }
    }]
  }), /*#__PURE__*/React.createElement("div", {
    className: "__content-wrap"
  }, /*#__PURE__*/React.createElement("div", {
    className: "__content"
  }, props.children)));
};
ELSModal.defaultProps = {
  disablePortal: true,
  placement: "bottom-start",
  dialogxswidth: "370px",
  dialogmwidth: "600px"
};